<template>
    <div class="notfound-root">
        <div class="brand text-center">
            <img src="/assets/layout/images/wilmar-logo.png" alt="logo" />
        </div>

        <div class="card">
            <div class="visual">
                <!-- Friendly robot SVG illustration -->
                <svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <defs>
                        <linearGradient id="g" x1="0" x2="1">
                            <stop offset="0" stop-color="#60a5fa" />
                            <stop offset="1" stop-color="#a78bfa" />
                        </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <circle cx="300" cy="300" r="260" fill="url(#g)" opacity="0.12" />
                        <g transform="translate(150 140)">
                            <rect width="300" height="220" rx="28" fill="#f8fafc" stroke="#e6edf6" />
                            <circle cx="90" cy="80" r="36" fill="#0ea5e9" opacity="0.12" />
                            <rect x="40" y="30" width="220" height="120" rx="12" fill="#fff" />
                            <g transform="translate(70 60)">
                                <rect width="20" height="10" rx="3" fill="#111827" opacity="0.08" />
                                <rect x="30" width="20" height="10" rx="3" fill="#111827" opacity="0.08" />
                                <circle cx="60" cy="48" r="28" fill="#eef2ff" stroke="#c7d2fe" />
                                <path d="M44 36c8 12 28 12 36 0" stroke="#7c3aed" stroke-width="4" stroke-linecap="round" />
                            </g>
                        </g>
                    </g>
                </svg>
            </div>

            <div class="content">
                <div class="code">404</div>
                <h1 class="title">Page not found</h1>
                <p class="desc">It looks like the page you&apos;re looking for doesn&apos;t exist or has been moved.</p>

                <div class="actions">
                    <router-link to="/" class="btn primary">Back to Home</router-link>
                </div>

                <div class="hint">Or double-check the URL.</div>
            </div>
        </div>
    </div>
</template>

<script setup>
// Komponen statis; navigasi menggunakan <router-link>
</script>

<style scoped>
.notfound-root{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2rem;background:linear-gradient(180deg,#f8fafc, #ffffff)}
.brand img{width:160px;height:auto;margin-bottom:1.25rem}
.card{display:flex;flex-direction:column;align-items:center;gap:1.25rem;background:linear-gradient(180deg,rgba(124,58,237,0.04),rgba(99,102,241,0.02));padding:2rem;border-radius:18px;box-shadow:0 6px 30px rgba(16,24,40,0.06);max-width:920px;width:100%}
.visual{width:100%;display:flex;justify-content:center}
.visual svg{width:320px;height:auto}
.content{display:flex;flex-direction:column;align-items:center;text-align:center;padding:0 1rem}
.code{font-weight:800;color:#7c3aed;font-size:3rem}
.title{font-size:1.75rem;margin:0.25rem 0;color:#111827}
.desc{color:#6b7280;margin-bottom:1rem}
.actions{display:flex;gap:0.75rem;flex-wrap:wrap;justify-content:center;margin-bottom:0.75rem}
.btn{padding:0.6rem 1rem;border-radius:8px;text-decoration:none;font-weight:600;border:1px solid transparent}
.btn.primary{background:linear-gradient(90deg,#6366f1,#7c3aed);color:#fff}
.btn.outline{background:transparent;border-color:#c7c8d9;color:#374151}
.hint{color:#9ca3af;font-size:0.9rem}

@media(min-width:900px){
    .card{flex-direction:row;padding:2.5rem}
    .visual svg{width:360px}
    .content{align-items:flex-start;text-align:left;padding-left:1.5rem}
}
</style>